import UpdateReport from './UpdateReport'
export default UpdateReport